import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { faLinkedin, faFacebook, faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'
import logo from '../images/new_logo.svg';
import profile from '../images/new_logo.svg';
import algoliasearch from "algoliasearch";
import ShowResults from './ShowResults';
import { isNotEmpty, signupCall, loginCall } from "../util/user";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faFlagCheckered, faGift, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faBell, faMoneyBillAlt, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import logoSmall from '../images/new_logo.svg';
import { AuthContext } from "../util/context";
import renderIf from "render-if";

const Navigation = () => {
  const { token, userData, setAuth } = useContext(AuthContext);
  let clientInit = algoliasearch('PTGN8U7BAB', '1bd38ecdf030101a4cff6d2447e8de2e');
  const [ searchingFor, setSearchingFor ] = useState("");
  const [ client, setClient ] = useState(clientInit);
  const [ showDiscover, setShowDiscover ] = useState(false);
  const [ showNotifications, setShowNotifications ] = useState(false);
  const [ isHiddenShow, setIsHiddenShow ] = useState(false);
  const [ results, setResults ] = useState([]);
  const [ similarResults, setSimilarResults ] = useState([]);

  let text = "User";
  let secondaryLine = "Post a Job";
  let secondaryLinkLine = "/account";
  let firstIcon = faFlagCheckered;

  if (token !== undefined && token !== null) {

  }

  useEffect(() => {
   document.addEventListener("mousedown", handleClick, false);

   return () => {
      document.addEventListener("mousedown", handleClick, false);
    };
  });

  const hideMenu = ()  => {
    const element = document.getElementById("nav-menu");

    if (element != undefined) {
      if (window.innerWidth <= 600) {
        const btn = document.getElementById("menu-btn");

        if (btn.checked) {
          btn.click();
        }
      }
    }
  }

  const handleKeyDown = e => {
    setIsHiddenShow(false);

    if (e.key === 'Enter') {
      goToSearch(e);
    }
  };

  const handleClick = (e) => {
    let node = document.getElementById("nav-menu-logged-in");
    // note: how to do?
    if (node === undefined) {
      return;
    }

    if (!isNotEmpty(node)) {
      return;
    }

    if (node.contains(e.target)) {
      return;
    }

    handleOutsideClick();
  }

  const handleOutsideClick = () => {
    setShowDiscover(false);
    setShowNotifications(false);
    setIsHiddenShow(true);
  }

  const goToSearch = (e) => {
    handleOutsideClick();
    // is this allowed? are there even props...
    const url = `/browse?search=${encodeURIComponent(e.target.value)}`;
    this.props.history.push(url);
  }

  const goToBrowse = (e) => {
    handleOutsideClick();
    const url = `/browse`;
    this.props.history.push(url);
  }

  const searchJobs = (e) => {
    const element = document.getElementById("exact-and-similar");

    if (element != undefined) {
      element.style.visibility = "visible";
    }

    setSearchingFor(e.target.value);

    var index = client.initIndex(process.env.REACT_APP_ALGOLIA);
    // title, type, description, skills
    index.search(e.target.value, function(err, content) {
      const resultsToShow = content.hits.filter((result) => isNotEmpty(result.title)).reverse().slice(0, 4);
      const similarResults = content.hits.filter((result) => isNotEmpty(result.title)).slice(0, 3);
      setResults(resultsToShow);
      setSimilarResults(similarResults)
    });
  }

  const showNavMenu = (type) => {
    let _otherType = type === "showDiscover" ? "showNotifications" : "showDiscover";

    if (type == "showDiscover") {
      setShowDiscover(true);
      setShowNotifications(false);
    } else {
      setShowDiscover(false);
      setShowNotifications(true);
    }
  }

  console.log('userData here', userData)

  let subcategories = [
    "Market Trends",
    "Active Listings",
    "Sold Listings",
    "Luxury Homes",
    "Neighbourhoods",
    "Hamilton Mountain",
    "East Hamilton",
    "Ancaster",
    "Stoney Creek",
    "Dundas",
    "Condos",
    "Townhouses",
    "Bungalows",
    "Semis",
    "Hamilton Realtors"
  ]

  return (
    <div className="header main-header">
      <div className="main-one">
        <div className="left">
          <Link className="main-logo" to="/">
            <img className="logo" src={logo} alt="Logo"/>
          </Link>
        </div>

        <div className="right">
          <input id="menu-btn" className="menu-btn" type="checkbox" id="menu-btn" />
          <label className="menu-icon" htmlFor="menu-btn"><span className="navicon"></span></label>

          <ul onClick={hideMenu} id="nav-menu" className="menu">
            <li className="stack-font">
              <div><Link className="black-font" to="/">Home</Link></div>
              <div><Link className="black-font" to="/buy">Buy</Link></div>
              <div><Link className="black-font" to="/sell">Sell</Link></div>
              <div><Link className="black-font" to="/browse">Listings</Link></div>
              <div><Link className="black-font" to="/about">About</Link></div>
            </li>
          </ul>
        </div>
      </div>

      <div className="sub-heading">
        <div className="right">

        </div>
      </div>
    </div>
  );
};

export default withRouter(Navigation);
